import ReviewsDashboard from "./ReviewsDashboard";

export default ReviewsDashboard;
